export const ICONS = {
  prev: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  cancel: 'fas fa-times',
  info: 'fas fa-circle-info',
  stop: 'fas fa-times-circle',
  retry: 'fas fa-redo',
  help: 'fas fa-question-circle',
  consent: 'fas fa-handshake',
  protection: 'fas fa-shield-halved',
  camera: 'fas fa-camera',
  yes: 'fas fa-check',
  no: 'fas fa-times',
  error: 'fas fa-bomb',
  comment: 'fas fa-comment',
  location: 'fas fa-map-marker-alt',
  donation: 'fas fa-comment-dollar',
  questionmark: 'fas fa-question',
  spinner: 'fas fa-spinner fa-spin',
  failed: 'fas fa-xmark',
  success: 'fas fa-check',
  selfieNext: 'fas fa-arrow-circle-right',
  selfiePrev: 'fas fa-arrow-circle-left',
  takeSelfie: 'fas fa-circle',
  shareSelfie: 'fas fa-share-square',
  switchCamera: 'fas fa-sync',
  selfie: 'fas fa-camera',
  rotate: 'fas fa-rotate',
  plus: 'fa-solid fa-angle-down fa-xl',
  minus: 'fa-solid fa-angle-up fa-xl',
};
